// ObjectUtil.ts
export class ObjectUtil {
    /**
     * Returns a new object without the specified field.
     *
     * @param obj The source object.
     * @param field The key to omit from the object.
     * @returns A new object without the specified field.
     */
    static omitField(obj, field) {
        const { [field]: omitted, ...rest } = obj;
        return rest;
    }
}
